import React, { useState, useEffect } from 'react';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Container,
  Row,
  Col,
} from 'reactstrap';

const PhotoBookAdminForm = ({ emailAddress: emailAddressProp = '', onButtonClick }) => {
  const [email, setEmail] = useState(emailAddressProp);

  useEffect(() => setEmail(emailAddressProp), [emailAddressProp]);

  const handleClick = (e) => {
    e.preventDefault();
    if (emailAddressProp !== email) {
      onButtonClick(email);
    }
  };

  return (
    <Form onSubmit={handleClick}>
      <FormGroup>
        <Label><b>Email Lovebox:</b></Label>
        <Container>
          <Row>
            <Col>
              <Input
                type="text"
                placeholder="Lovebox email address"
                value={email}
                onChange={({ target: { value } }) => setEmail(value)}
              />
            </Col>
            <Col>
              <Button
                type="submit"
                color="success"
              >
                Change Lovebox account
              </Button>
            </Col>
          </Row>
        </Container>
      </FormGroup>
    </Form>
  );
};

export { PhotoBookAdminForm };



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/form/photobook-admin-form.js